// extracted by mini-css-extract-plugin
export default {"form":"Form_form__DVxTD","formHead":"Form_formHead__TaOQK","formGroup":"Form_formGroup__2ml9G"};